import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import Tooltip from "@mui/material/Tooltip";
import { StyledAddress } from "./Address.styled";
const Address = (props) => {
    const { value, strong = false, shorten = true, tooltip = false } = props;
    const address = useMemo(() => (shorten ? `${value.slice(0, 6)}\u2026${value.slice(-4)}` : value), [value, shorten]);
    const content = (_jsx(StyledAddress, { as: strong ? "strong" : "span", children: address }));
    return tooltip ? (_jsx(Tooltip, { title: value, placement: "top", children: _jsx("span", { children: content }) })) : (content);
};
export { Address };
//# sourceMappingURL=Address.js.map